import UIComponent from "../component";

export class CancelRenewalBtn extends UIComponent {
    init() {
      this.includeComponents({
            cancel_modal: 'document@#cancelRenewalModal'
        });

        this.on("click" , () => this.OpenCancelModal())
  
    }

    OpenCancelModal () {
        this.cancel_modal.show()
    }

  
}